import { EnviromentZone, HowdenLoginBehaviour, HowdenLoginKind, IHowdenEnvironment, LogLevel } from '@howdeniberia/core-front';

export const environment = {
  zone: EnviromentZone.DEVELOPMENT,
  appIdSecurity: 5,
  loginBehaviour: HowdenLoginBehaviour.REDIRECT,
  howdenLoginUrl: 'https://how-login.app-dev.howdeniberia.com',
  loginKind: HowdenLoginKind.INTERNAL,
  logLevel: LogLevel.INFO
} as IHowdenEnvironment;
